<ol class="breadcrumb">
    <breadcrumbs></breadcrumbs>
</ol>
<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <div class="card">
                <div class="card-header">
                    レポート管理
                </div>
                <div class="card-body">
                    <div class="card">
                        <div class="card-header">
                            <div class="form-group row">
                                <label class="col-md-1 form-control-label">レポート名</label>
                                <div class="col-md-1">
                                    <select class="form-control" [(ngModel)]="name">
                                        <option *ngFor="let item of reports" [ngValue]="item.name"> {{item.name}}</option>
                                    </select>
                                </div>
                                <div class="col-md-2">
                                    <input type="text" [(ngModel)]="name" class="form-control" placeholder="レポート名">
                                </div>
                                <div class="col-md-2">
                                    <button (click)="displayReport()" class="btn btn-info btn-block">表示</button>
                                </div>
                                <div class="col-md-2">
                                    <button (click)="editReport()" class="btn btn-primary btn-block">編集</button>
                                </div>
                                <div class="col-md-2">
                                    <button (click)="saveReport()" class="btn btn-success btn-block">保存</button>
                                </div>
                                <div class="col-md-2">
                                    <button (click)="confirmRemoveReport()" class="btn btn-danger btn-block">削除</button>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div id="designerContent"></div>
                            <div id="viewerContent"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<cb-modal-confirm #removeReportPopup (onConfirm)="removeReport()" [modalClass]="'modal-danger'" [closeButton]="'キャンセル'" [confirmButton]="'削除'" [title]="'削除'" [content]="'本当に' + name + 'を削除しますか？'"></cb-modal-confirm>
